module.exports = __webpack_public_path__ + "img/atout.6fec0fa3.png";